import { call_api } from "@approck_web/app_socket.mts";
import {
    type JsonValue,
    type Option,
    Option_decode,
    Option_encode,
    type Result,
    string_decode,
    string_encode,
} from "@artyp/lib.mts";

export namespace login_submit {
    // InnerAdt::NamedStruct: Input
    export type Input = { username: Option<string>; password: Option<string>; };

    // InnerAdt::NamedStruct: Input
    export function Input_encode(_value: Input): JsonValue {
        return {
            username: ((v) => {
                return Option_encode(v, string_encode);
            })(_value["username"]),
            password: ((v) => {
                return Option_encode(v, string_encode);
            })(_value["password"]),
        };
    }

    // InnerAdt::NamedStruct: InputErr
    export type InputErr = { username: Option<string>; password: Option<string>; };

    // Adt::NamedStruct: InputErr
    export function InputErr_decode(_data: JsonValue): Result<InputErr, string> {
        if (typeof _data === "object" && _data !== null && !Array.isArray(_data)) {
            const r_username = ((v) => {
                return Option_decode(v, string_decode);
            })(_data["username"] ?? null);
            if ("Err" in r_username) return r_username;
            const r_password = ((v) => {
                return Option_decode(v, string_decode);
            })(_data["password"] ?? null);
            if ("Err" in r_password) return r_password;
            return { Ok: { "username": r_username.Ok, "password": r_password.Ok } };
        } else return { Err: "Named: wrong type: " + typeof _data };
    }

    // InnerAdt::Enum: Output
    export type Output = { Ok: { redirect_url: string; }; } | { InputErr: [InputErr]; } | {
        Failed: { message: string; };
    };

    // Adt::Enum: Output
    export function Output_decode(_data: JsonValue): Result<Output, string> {
        if (typeof _data === "object" && _data !== null && !Array.isArray(_data)) {
            if (
                "Ok" in _data && typeof _data["Ok"] === "object" && _data["Ok"] !== null
                && !Array.isArray(_data["Ok"])
            ) {
                const _obj = _data["Ok"];
                const redirect_url = string_decode(_obj["redirect_url"] ?? null);
                if ("Err" in redirect_url) return redirect_url;
                return { Ok: { "Ok": { "redirect_url": redirect_url.Ok } } };
            }
            if ("InputErr" in _data && Array.isArray(_data["InputErr"])) {
                const arr = _data["InputErr"];
                const v_0 = InputErr_decode(arr[0] ?? null);
                if ("Err" in v_0) return v_0;
                return { Ok: { "InputErr": [v_0.Ok] } };
            }
            if (
                "Failed" in _data && typeof _data["Failed"] === "object" && _data["Failed"] !== null
                && !Array.isArray(_data["Failed"])
            ) {
                const _obj = _data["Failed"];
                const message = string_decode(_obj["message"] ?? null);
                if ("Err" in message) return message;
                return { Ok: { "Failed": { "message": message.Ok } } };
            }
        }
        return { Err: "invalid variant" };
    }

    // api call function for `login_submit`
    export const api = {
        api: "::web::login::index::login_submit",
        call: call,
        Input_encode: Input_encode,
        Output_decode: Output_decode,
    };

    export async function call(data: Input): Promise<Output> {
        const { promise } = call_api("::web::login::index::login_submit", Input_encode(data));
        const output = await promise;
        const r = Output_decode(output);
        if ("Err" in r) throw r.Err;
        return r.Ok;
    }
}
